import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import { IAlertComponent, IButtonDirective, MODAL_DATA, ModalRef } from "@front/m19-ui";
import { DspAudienceCreateResponse } from "@front/m19-api-client";

@Component({
  selector: "app-dsp-create-audiences-result",
  imports: [TranslocoDirective, IAlertComponent, IButtonDirective],
  templateUrl: "./dsp-create-audiences-result-modal.component.html",
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DspCreateAudiencesResultModalComponent {
  private readonly modalData = inject<DspAudienceCreateResultModalData>(MODAL_DATA);
  protected readonly modalRef = inject(ModalRef);

  private audiencesCreateResult = this.modalData.audiencesCreateResult;
  createdAudiences = this.audiencesCreateResult?.createdDspAudiences;
  erroredAudiences = this.audiencesCreateResult?.erroredDspAudiences;

  close() {
    this.modalRef.close(true);
  }
}

export interface DspAudienceCreateResultModalData {
  audiencesCreateResult: DspAudienceCreateResponse | undefined;
}
